<template>
<div>
  <div style="color:#606266;height:50px;width:100%;background-color:#E4E7ED;text-align:left;font-size:16px;line-height:50px;font-weight:bold;padding-left:10px;">参数设置</div>
  <div style="padding:20px;border-left:1px solid #E4E7ED;border-right:1px solid #E4E7ED;border-bottom:1px solid #E4E7ED;">
    <el-form ref="form" :model="form" :rules="rules" label-width="500px" class="ques_relus">
      <el-form-item label="下属离职倾向识别时间间隔">
        <el-tooltip effect="dark" content="主管间隔多久可以识别一次下属的离职倾向，单位：天。" placement="top-start">
            <el-input v-model="form.research_interval" placeholder="请配置为正整数" :disabled="!enable"></el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="工作动机（非常重要/非常不满意）勾选数量">
        <el-tooltip effect="dark" content="工作动机中非常重要/非常不满意项要求勾选的数量。" placement="top-start">
          <el-input v-model="form.motivation_maxnum_1" placeholder="请配置为正整数" :disabled="!enable"></el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="工作动机（比较重要/比较满意）勾选数量">
        <el-tooltip effect="dark" content="工作动机中比较重要/比较满意项要求勾选的数量。" placement="top-start">
          <el-input v-model="form.motivation_maxnum_2" placeholder="请配置为正整数" :disabled="!enable"></el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="工作动机（不重要/满意）勾选数量">
        <el-tooltip effect="dark" content="工作动机中不重要/满意项要求勾选的数量。" placement="top-start">
          <el-input v-model="form.motivation_maxnum_3" placeholder="请配置为正整数" :disabled="!enable"></el-input>
        </el-tooltip>
      </el-form-item>
    </el-form>
    <div style="margin-top:20px;">
    <!-- <el-button @click="Cancel_config">取消</el-button> -->
    <el-button type="primary" @click="Submit_config" :disabled="!enable">保存</el-button>
    </div>
  </div>
</div>
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
      this.Cancel_config();
    },
    data() {
        return {
          form: {
              research_interval: 30,
              motivation_maxnum_1: 5,
              motivation_maxnum_2: 6,
              motivation_maxnum_3: 5,
          },
          enable: true,
          rules: {
            // trigger类型为blur的功能是文本框失去焦点才会触发
            // trigger类型为change的功能是文本框在输入内容时触发
            research_interval: [
              {required: true, message: '请配置为大于等于0的整数！', trigger: 'blur'},
              {type: 'integer', message: '请配置为大于等于0的整数！', trigger: 'blur'},
            ],
            motivation_maxnum_1: [
              {required: true, message: '请配置为大于等于0的整数！', trigger: 'blur'},
              {type: 'integer', message: '请配置为大于等于0的整数！', trigger: 'blur'},
            ],
            motivation_maxnum_2: [
              {required: true, message: '请配置为大于等于0的整数！', trigger: 'blur'},
              {type: 'integer', message: '请配置为大于等于0的整数！', trigger: 'blur'},
            ],
            motivation_maxnum_3: [
              {required: true, message: '请配置为大于等于0的整数！', trigger: 'blur'},
              {type: 'integer', message: '请配置为大于等于0的整数！', trigger: 'blur'},
            ],
          },
          params_info: {},
        }
      },
      props: ['task_id'],
      methods: {
        Cancel_config() {
          // 取消即从服务器获取此前已保存的配置，并覆盖当前的配置
          let params;
          params = {
              'task_id': this.task_id,
          }
          getdata.getListP("getRCConfigs", params)
            .then(resp => {
                if(resp.data.code == 200){
                    // 新建参数时不使用获取的参数更新前端
                    if(resp.data.flag == 1){
                      this.form = resp.data.data;
                      this.enable = resp.data.enable;
                    }                    
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        Submit_config() {
          this.form.task_id = this.task_id;
          postdata.postList("submitRCConfigs", JSON.stringify(this.form))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                  })
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                  })
                }
              })
              .catch(err => {
                console.log(err);
              })
        }
      }
}
</script>

<style scoped>
.el-table {
    /* font-size: 18px; */
    margin-top: 10px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* ::v-deep .el-input {
    font-size: 18px;
} */
.el-button {
    font-size: 16px;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.ques_relus {
  text-align: left;
}
.ques_relus /deep/ .el-input {
  width: 300px;
}
</style>